import logo from "./logo.svg";
import "./App.css";
import Routers from "./Component/Router/Router";

function App() {
  return (
    <div className="App">
      <Routers />
    </div>
  );
}

export default App;
